module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAQAAAAnOwc2AAAAa0lEQVQIW2NgYPgv83/Z/2dAuOy/DAMEAIXe/oeBt1BhoDwSeL+RgQ0k+AxZ8NdrBgOgMIagMYMSmvbn24GCeigW/fmQ5AkWBNn/fuOv179eP98OFgJpBwM2oPEgLgiCLIICNqC8HhAqgYQA1QNvYNOUaFIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Flourishes/fancy_circle.png
// module id = 1554
// module chunks = 1